/** Dev: empty string → Vite proxies `/api` to localhost:8888 (see vite.config.ts). */
export const WW_API_BASE_URL =
  (import.meta.env.VITE_WW_API_URL as string | undefined)?.replace(/\/$/, '') ??
  (import.meta.env.DEV ? '' : 'https://api.wagerwatchdog.com');

export const APP_URL = 'https://app.wagerwatchdog.com';

export const SIGNUP_URL = `${APP_URL}/signup`;

export const APP_RATINGS_URL = `${APP_URL}/ratings`;
